import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCMN9_yG9s01XN77c0w9QJNALBY1a_xX-8",
  authDomain: "nypblockchain-e3f16.firebaseapp.com",
  projectId: "nypblockchain-e3f16",
  storageBucket: "nypblockchain-e3f16.appspot.com",
  messagingSenderId: "113617119168",
  appId: "1:113617119168:web:5b8ab241e21d6b3bfc4a25",
  measurementId: "G-KX3T728EW4"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };